// export const EMBEDDED_SECONDARY_BUTTON_AB_TEST = {
//   test_name: "embedded_secondary_button_v2_ab_test",
//   new_variation_name: "new_with_embedded",
//   platform_segment_key: "bb3001",
//   button_text: "signup.tryItOut"
// };

module.exports = [];
